module.exports = __webpack_public_path__ + "img/ljxscs.b63d37ce.png";